import _map from 'lodash/map';

const componentName = 'MapAndFloorplan';

const classes = {
	touch: 'touch',
	zoomed: `${componentName}-floorPlanWrapper--zoomed`,
};

const selectors = {
	floorPlan: `.${componentName}-FloorPlan`,
	floorPlanWrapper: `.${componentName}-floorPlanWrapper`,
	floorPlanContainer: `.${componentName}-floorPlanContainer`,
	floorPlanImage: `.${componentName}-floorPlanImage`,
	zoomInButton: `.${componentName}-floorPlanZoomIn`,
	zoomOutButton: `.${componentName}-floorPlanZoomOut`,
	floorSelect: `.${componentName}-floorPlanSelect`,
};

const basePosition = 50;

const viewerProps = {
	zoomValue: 1,
	zoomIncrement: 1,
	zoomMin: 1,
	zoomMax: 4,
	mouseDownPos: [basePosition, basePosition],
	clickCurrentPos: [basePosition, basePosition],
	elemPos: [basePosition, basePosition],
	isMouseDown: false,
	zoomed: false,
	container: null,
	selectedImage: null,
	imageRangeModifier: [0, 0],
	inBoundaries: [
		[true, true], // [is valid X min, is valid X max]
		[true, true], // [is valid Y min, is valid Y max]
	],
};

/**
 * Set transform styles to floor plan container
 * @param {string} value
 */
const setTransformValues = value => {
	viewerProps.container.css({
		'-webkit-transform': value,
		'-moz-transform': value,
		'-ms-transform': value,
		'-o-transform': value,
		transform: value,
	});
};

/**
 * Zooms in or out the floor plan container
 * @param {bool} isIncrement - A flag that tells if the
 * scale should increase or decrease
 */
const scaleContainer = isIncrement => {
	const value = isIncrement
		? viewerProps.zoomValue + viewerProps.zoomIncrement
		: viewerProps.zoomValue - viewerProps.zoomIncrement;

	if (value < viewerProps.zoomMin || value > viewerProps.zoomMax) {
		return false;
	}

	// Detect zoom out on zoom greater than 100%
	if (value !== 1 && value < viewerProps.zoomValue) {
		viewerProps.elemPos = [basePosition, basePosition];
		moveFloorPlan();
	}

	viewerProps.zoomValue = value;
	setImageRangeModifier();

	if (value > viewerProps.zoomMin) {
		viewerProps.zoomed = true;
		$(selectors.floorPlanWrapper).addClass(classes.zoomed);
	} else {
		viewerProps.zoomed = false;
		$(selectors.floorPlanWrapper).removeClass(classes.zoomed);
		viewerProps.elemPos = [basePosition, basePosition];
		moveFloorPlan();
	}

	setTransformValues(`translate(-${basePosition}%, -${basePosition}%) scale(${value})`);
};

/**
 * Reset the state of the floor plan
 */
const resetFloorPlan = () => {
	viewerProps.zoomValue = viewerProps.zoomMin;
	setImageRangeModifier();
	viewerProps.mouseDownPos = [basePosition, basePosition];
	viewerProps.clickCurrentPos = [basePosition, basePosition];
	viewerProps.elemPos = [basePosition, basePosition];

	setTransformValues(`translate(-${basePosition}%, -${basePosition}%) scale(1)`);

	viewerProps.zoomed = false;
	$(selectors.floorPlanWrapper).removeClass(classes.zoomed);
	viewerProps.elemPos = [basePosition, basePosition];
	setImageRangeModifier();
	moveFloorPlan();
};

/**
 * Handles zoom in button click
 * @param {object} event - A click event
 */
const handleZoomIn = event => {
	scaleContainer(true);
};

/**
 * Handles zoom out button click
 * @param {object} event - A click event
 */
const handleZoomOut = event => {
	scaleContainer(false);
};

/**
 * Image range modifier allows viewer
 * to set min and max boundaries for X and Y
 * based on the size of the image
 */
const setImageRangeModifier = () => {
	const imageSize = [viewerProps.selectedImage.width(), viewerProps.selectedImage.height()];
	const containerSize = [viewerProps.container.width(), viewerProps.container.height()];

	const zoomedImageSize = [imageSize[0], imageSize[1]];

	const containerImageRatio = [
		100 * viewerProps.zoomValue * (imageSize[0] / containerSize[0]).toFixed(2),
		100 * viewerProps.zoomValue * (imageSize[1] / containerSize[1]).toFixed(2),
	];

	viewerProps.imageRangeModifier = [
		(containerImageRatio[0] - 50) / 2,
		(containerImageRatio[1] - 50) / 2,
	];
};

/**
 * Makes a floor visible and hide the rest
 * @param {number} floor - A floor image index
 */
const selectFloor = floor => {
	const dataIndexSelector = `[data-index="${floor}"]`;

	viewerProps.selectedImage = $(`${selectors.floorPlanImage}${dataIndexSelector}`);
	viewerProps.selectedImage.show();

	const otherImages = $(`${selectors.floorPlanImage}`).not(viewerProps.selectedImage);
	otherImages.hide();

	resetFloorPlan();
	setImageRangeModifier();
};

/**
 * Handles floor select change
 * @param {object} event - An onChange event
 */
const handleFloorSelect = event => {
	selectFloor($(event.target).val());
};

/**
 * Checks if a position aray fits in the
 * boundaries of the container
 * @param {array} positionArray - The new position array
 */
const isValidBoundary = positionArray => {
	return _map(positionArray, (axis, index) => {
		const minBoundary = basePosition - viewerProps.imageRangeModifier[index];
		const maxBoundary = basePosition + viewerProps.imageRangeModifier[index];
		const validMin = axis > minBoundary;
		const validMax = axis < maxBoundary;
		viewerProps.inBoundaries[index] = [validMin, validMax];

		return validMin && validMax;
	});
};

/**
 * Set css styles for floor plan container
 * new position
 */
const moveFloorPlan = () => {
	viewerProps.container.css({
		left: `${viewerProps.elemPos[0]}%`,
		top: `${viewerProps.elemPos[1]}%`,
	});
};

/**
 * Validates new floor plan container
 * positioning and attempts to re-locate it
 * @param {int} newX
 * @param {int} newY
 */
const processFloorPlanMovement = (newX, newY) => {
	const mouseInitX = viewerProps.mouseDownPos[0];
	const mouseInitY = viewerProps.mouseDownPos[1];

	const delta = [
		(newX - mouseInitX) / (100 / viewerProps.zoomValue),
		(newY - mouseInitY) / (100 / viewerProps.zoomValue),
	];
	const newPos = [viewerProps.elemPos[0] + delta[0], viewerProps.elemPos[1] + delta[1]];
	const validBoundary = isValidBoundary(newPos);

	viewerProps.elemPos = [
		validBoundary[0] ? newPos[0] : viewerProps.elemPos[0],
		validBoundary[1] ? newPos[1] : viewerProps.elemPos[1],
	];

	moveFloorPlan();
};

/**
 * Handles mouse move event
 * @param {object} event - A mousemove event
 */
const handleMouseMove = event => {
	if (viewerProps.zoomed && viewerProps.isMouseDown) {
		processFloorPlanMovement(event.clientX, event.clientY);
	}
};

/**
 * Handles mouse down event
 * @param {object} event - A mousedown event
 */
const handleMouseDown = event => {
	if (viewerProps.zoomed) {
		viewerProps.isMouseDown = true;
		viewerProps.mouseDownPos = [event.clientX, event.clientY];
	}
};

/**
 * Handles mouse up event
 * @param {object} event
 */
const handleMouseUp = event => {
	viewerProps.isMouseDown = false;
};

/**
 * Handles touch move event
 *
 * First it asks for a zoomed image, then checks
 * if current movement is in a valid Y min and Y max
 * position allowing users to scroll internally,
 * otherwise normal scroll event will take place.
 *
 * @param {object} event
 */
const handleTouchMove = event => {
	if (viewerProps.zoomed && viewerProps.isMouseDown && event.changedTouches[0]) {
		if (viewerProps.inBoundaries[1][0] && viewerProps.inBoundaries[1][1]) {
			event.preventDefault();
		}

		processFloorPlanMovement(event.changedTouches[0].clientX, event.changedTouches[0].clientY);
	}
};

/**
 * Handles touch start event
 * @param {object} event
 */
const handleTouchStart = event => {
	if (viewerProps.zoomed) {
		viewerProps.isMouseDown = true;
		viewerProps.mouseDownPos = [event.targetTouches[0].clientX, event.targetTouches[0].clientY];
	}
};

/**
 * Handles touch end event
 * @param {event} event
 */
const handleTouchEnd = event => {
	viewerProps.isMouseDown = false;
};

/**
 * Initializes events
 */
const initEvents = () => {
	$(window).on('resize', resetFloorPlan);
	$(selectors.zoomInButton).click(handleZoomIn);
	$(selectors.zoomOutButton).click(handleZoomOut);
	$(selectors.floorSelect).change(handleFloorSelect);

	if ($('body').hasClass(classes.touch)) {
		$(selectors.floorPlanWrapper).on('touchmove', handleTouchMove);
		$(selectors.floorPlanWrapper).on('touchstart', handleTouchStart);
		$(window).on('touchend', handleTouchEnd);
	} else {
		$(selectors.floorPlanWrapper).mousemove(handleMouseMove);
		$(selectors.floorPlanWrapper).mousedown(handleMouseDown);
		$(window).mouseup(handleMouseUp);
	}
};

/**
 * Initializes component
 */
export default function init() {
	viewerProps.container = $(selectors.floorPlanContainer);

	if (viewerProps.container.length > 0) {
		selectFloor(0);
		initEvents();
	}
}
